import React from "react";
import Comingsoonpage from "../../../common/Comingsoon";

const BroadcastMessages = () => {
  return (
    <div>
      <Comingsoonpage />
    </div>
  );
};

export default BroadcastMessages;
